import TestButton from '../components/TestButton';

function GroceryStore() {
  return (
    <div>
      <TestButton />
    </div>
  );
}

export default GroceryStore;
